/**
 * Created by claude on 22.07.26.
 * Scene component extracted from ChatScene
 */

class ChatSceneComponent extends ScriptComponent {
    onCreate() {
        this.chat = (PrefabBuilder.resolveProperty(this.options.args, this.context) || [])[0];
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setBundles(this.listBundles());
    }

    buildChatHeader() {
        return new ChatHeader(this.chat);
    }

    buildChatView() {
        return new ChatView(this.chat);
    }

    buildChatInput() {
        return new ChatInput(this.chat);
    }

    onReady() {
        cleverapps.placements.run(Placements.INTERMEDIATE);

        if (this.chat.hasUnread) {
            const lastReplyMessage = this.chat.getLastMessage();
            if (lastReplyMessage && lastReplyMessage.isResponse === 1) {
                cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.CRM.REPLY);

                if (lastReplyMessage.status === "resolved") {
                    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.CRM.RESOLVED);
                }

                const lastUserMessage = this.chat.getLastMessage(true);
                if (lastUserMessage && new Date(lastReplyMessage.postDate) - new Date(lastUserMessage.postDate) > Chat.LATE_REPLY_INTERVAL) {
                    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.CRM.LATE_REPLY);
                }
            }

            this.chat.markAsRead();
        } else {
            const msg = this.chat.getLastMessage();
            if (msg && msg.isResponse !== 1 && new Date(msg.postDate) + Chat.LATE_REPLY_INTERVAL > Date.now()) {
                cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STATS.CRM.UNANSWERED);
            }
        }
    }

    listBundles() {
        const result = ["chat"];
        if (["merge", "merge2"].includes(cleverapps.config.type)) {
            result.push("episode_0");
        }
        return result;
    }
}

Prefab.registerComponent("ChatSceneComponent", ChatSceneComponent);
